import '@assets/styles/pages/meeting-details.scss';
import { MeetingDetails } from '@components/meeting-details/meetingDetails';
import { ReactElement } from 'react';

export const MeetingDetailsPage = (): ReactElement => {
	return <MeetingDetails />;
};
